import React, { createContext, useState } from 'react';
import screenfull from 'screenfull';
import Logger from '@/lib/logger';
import { jsx as _jsx } from "react/jsx-runtime";
export var FullScreenContext = /*#__PURE__*/createContext({
  enter: function enter() {},
  exit: function exit() {},
  isEnabled: false
});
var sf = screenfull;

var onFullScreenError = function onFullScreenError(_ref) {
  var message = _ref.message,
      stack = _ref.stack;
  Logger.warning(message, {
    stack: stack
  });
};

var FullScreenProvider = function FullScreenProvider(_ref2) {
  var children = _ref2.children;

  var _useState = useState(false),
      isEnabled = _useState[0],
      setIsEnabled = _useState[1];

  var enter = function enter() {
    setIsEnabled(true);
  };

  var exit = function exit() {
    setIsEnabled(false);
  };

  if (sf.isEnabled) {
    if (isEnabled) {
      sf.request()["catch"](onFullScreenError);
    } else {
      sf.exit()["catch"](onFullScreenError);
    }
  }

  return /*#__PURE__*/_jsx(FullScreenContext.Provider, {
    value: {
      enter: enter,
      exit: exit,
      isEnabled: isEnabled
    },
    children: children
  });
};

export default FullScreenProvider;